<template>
  <div class="dashboard">
    <div class="dashboard-content">
      <div class="dashboard-header" v-loading="loading.departments">

        <el-dropdown size="medium">
          <span class="el-dropdown-link">
             <h1 class="dashboard-content__title">{{ currentDepartment.title }}</h1><i
              class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="department of departmentList" :key="department.id">{{ department.title }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <date-picker v-model="currentDate" @change="getAppointmentsData"></date-picker>
      </div>

      <div class="top-panel">
        <el-radio-group v-model="currentTypeAppointment" class="departments-radio-group">
          <el-radio-button v-for="item in typeAppointment" :label="item.label" :key="item.label">
            {{ item.title }}
          </el-radio-button>
        </el-radio-group>
        <div class="counters" v-loading="loading.doctorInfo">

          <div class="counters__value">Непросмотренные скрининги
            <div class="counters__value_red">{{ doctorInfo }}</div>
          </div>
        </div>
      </div>

      <el-table @sort-change="editSort" v-loading="loading.appointmentsData" :data="usersList" @row-click="openUser" class="zebra-table">
        <el-table-column width="70" prop="" label="">
          <template slot-scope="scope">
            <letters-avatar v-if="scope.row" :name="scope.row.name" size="32" type="mini"/>
          </template>
        </el-table-column>

        <el-table-column sortable="custom" prop="name" label="Клиент">
          <template slot-scope="scope">
            <div class="user-data">
              <div class="user-data__name">{{ scope.row.name }}</div>
              <div class="user-data__phone"> {{ scope.row.phone }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column sortable="custom" width="70" prop="id" label="ID"></el-table-column>
        <el-table-column sortable="custom" prop="last_screening" label="Последнее посещение" :formatter="formatter">
          <template slot-scope="scope">

            <div class="time-point" v-if="scope.row.last_screening">
              <div class="time-point__date">{{ $root.dateDefault(scope.row.last_screening) }}</div>
              <div class="time-point__time"><i class="el-icon-time"></i> {{ $root.timeIso(scope.row.last_screening) }}
              </div>
            </div>

          </template>
        </el-table-column>
        <el-table-column sortable="custom" prop="last_activity" label="Последняя активность">
          <template slot-scope="scope">

            <div class="time-point" v-if="scope.row.last_activity">
              <div class="time-point__date">{{ $root.dateDefault(scope.row.last_activity) }}</div>
              <div class="time-point__time"><i class="el-icon-time"></i> {{ $root.timeIso(scope.row.last_activity) }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="50" label="" align="right">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.check_appointment" content="Необходима валидация" placement="top">
              <attention-icon/>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
          v-if="showPagination"
          class="pagination"
          background
          layout="prev, pager, next"
          :page-size="pagination.per_page"
          :total="pagination.total"
          :current-page="pagination.current_page"
          @current-change="editPage"
      />

    </div>

  </div>
</template>

<script>
import DatePicker from "@/components/ganttCalendar/DatePicker"
import AttentionIcon from "@/components/icons/Attention"
import LettersAvatar from "@/components/elements/LettersAvatar"

export default {
  name: "Dashboard.visit",
  data: function () {
    return {
      loading: {
        departments: true,

        doctorInfo: true,
        appointmentsData: true,
      },
      currentDate: new Date(),
      currentDepartment: {},
      departmentList: [],
      appointments: [],
      pagination: [],
      usersList: [],
      doctorInfo: {},
      sort: {},
      search: {
        departmentId: 0,
        inspectionStatus: null,
        phone: null,
        id: null,
      },
      currentTypeAppointment: 'all',
      typeAppointment: [
        {
          label: 'all',
          title: 'Все записи',
        },
        // {
        //   label: 'screening_plus',
        //   title: 'Черновик'
        // },
        {
          label: 'screening_plus',
          title: 'Новые'
        }
      ],
    }
  },
  computed: {
    showPagination() {
      if (this.pagination) {
        return this.pagination.total > this.pagination.per_page
      } else return false
    },
    isToday() {
      return this.currentDate.toDateString() === new Date().toDateString()
    }
  },
  components: {
    DatePicker,
    AttentionIcon,
    LettersAvatar
  },
  watch: {
    currentTypeAppointment() {
      this.getAppointmentsData()
    }
  },
  created() {

  },
  mounted() {
    this.currentDate = new Date()

    this.getDepartments()
    this.loadList();
  },
  methods: {
    editSort(column) {

      this.loadList(1, {
        order: column.order,
        prop: column.prop
      })

    },
    formatter(row) {
      return row.address
    },
    openUser(visit) {
      this.$router.push({name: "user.item", params: {id: visit.id}});
    },
    loadList(page = 1, sort = {}) {
      this.loading.appointmentsData = true

      let params = {
        params: {
          page,
          limit: 15,
          sortedBy: sort.order === 'ascending' ? 'asc' : sort.order === 'descending' ? 'desc' : null,
          orderBy: sort.prop  ? sort.prop : null,
          search: this.search.phone ? this.search.phone : null,
        }
      }

      this.$api.user
          .list(params)
          .then((response) => {
            this.usersList = response.data.data;

            if (response.data.meta)
              this.pagination = response.data.meta.pagination;
          })
          .catch(() => {
            this.$notify.error({
              title: "Ошибка загрузки списка 😕",
            })
          })
          .finally(() => {
            this.loading.appointmentsData = false
          })
    },
    loadMainData() {
      this.getAppointmentsData()
    },
    getDepartments() {
      this.loading.departments = true

      this.$api.session
          .getDepartments("lite")
          .then((response) => {
            this.departmentList = response.data
            this.currentDepartment = response.data[0]

            this.loadMainData()
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки списка центров 😕",
              message: response.response.data.message,
            })
          })
          .finally(() => {
            this.loading.departments = false
          })
    },
    getCardioInfo(param) {
      if (!this.cardioDeviceInfo.info) return {}
      return this.cardioDeviceInfo.info.find(item => item.code === param)
    },
    editPage(page) {
      this.getAppointmentsData(this.currentDate, page)
    },
    getAppointmentsData(date, page = 1) {
      this.loading.doctorInfo = true
      this.loading.appointmentsData = true

      let payload = {
        params: {
          departments: [this.currentDepartment.id],
          calendar_date: date ? date : this.$root.dateBack(this.currentDate),
          type: this.currentTypeAppointment,
          limit: 10,
          page: page
        }
      }

      this.$api.dashboard
          .getAppointmentsData(payload)
          .then((response) => {
            this.appointments = response.data.data
            this.pagination = response.data.meta.pagination
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки записей 😕",
              message: response.response.data.message,
            })
          })
          .finally(() => {
            this.loading.appointmentsData = false
            this.getdoctorInfo()
          })
    },
    getdoctorInfo() {
      this.loading.doctorInfo = true

      let payload = {
        params: {
          departments: [this.currentDepartment.id],
          calendar_date: this.$root.dateBack(this.currentDate),
          type: this.currentTypeAppointment,
        }
      }

      this.$api.visit
          .getListByDoctorInfo(payload)
          .then((response) => {
            this.doctorInfo = response.data.new_count
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки счетчиков записей 😕",
              message: response.response.data.message,
            })
          })
          .finally(() => {
            this.loading.doctorInfo = false
          })
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/zebra-table.scss";

.zebra-table {
  margin-top: 20px;

  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 16px;
  color: #676767;

  /deep/ .el-table__row {
    height: 60px;
  }
}

.procedure {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 22px;

  &__title {
    font-weight: 600;
    font-size: 15px;
    line-height: 16px;
    color: #111;
  }

  &__icon {
    width: 32px;
    max-height: 32px;
  }
}

.user-data {
  display: flex;
  align-items: center;
  //justify-content: flex-end;
  gap: 8px;

  &__name {
    color: #676767;
  }

  &__phone {
    color: #111111;
  }
}

.dashboard {
  margin-top: 50px;
  width: 100%;
}

.dashboard-content {
  box-sizing: border-box;
  overflow: hidden;
  padding: 0 72px;

  max-width: 1200px;
  margin: 16px auto;

  &__title {
    margin: 0;
    padding: 0;

    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 26px;
    color: #111;
  }

  &__sub-title {
    margin: 32px 0 16px 0;
    padding: 0;

    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    color: #111;
  }
}

.top-panel {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.counters {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__value {
    margin-left: 16px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    font-size: 14px;
    line-height: 16px;

    letter-spacing: -0.005em;
    color: #676767;

    &_red {
      color: #E06161;
    }

    &_green {
      color: #43D3B3;
    }

    div {
      margin-left: 6px;

      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
    }
  }
}

.departments-radio-group {
  margin: 13px 0;
}

.dashboard-header {
  margin: 16px auto;
  display: flex;
  align-items: center;
}


.el-dropdown-link {
  display: flex;
  align-items: center;
}

/deep/ th.is-leaf, td {
  padding: 14px 0 !important;
  border-bottom: none;
}
</style>
